import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import { Heading } from 'components/chroma';
import { MotorGroupStepType } from 'scenes/motor/types';

const HeadingWrapper = styled.div`
  h1 {
    margin-top: 12px;
    font-family: 'Source Sans Pro', sans-serif !important;
    font-weight: 700;
    margin-right: 0 !important;
  }
`;

const FlowDescription: FunctionComponent<{
  stepNumber: number;
  flowName: MotorGroupStepType;
}> = ({ stepNumber, flowName }) => (
  <HeadingWrapper>
    <Heading
      size={1}
      margin={{ bottom: 0, right: 3 }}
      fontSize={{ xs: 16, sm: 18 }}
      textAlign="center"
    >
      {stepNumber}. {flowName}
    </Heading>
  </HeadingWrapper>
);

export default FlowDescription;
